export class ContainerComponent {
    constructor(state, callback) {
        this.state_key_name = state._name;
        this.callback = callback;
    }
}
export class ContainerController {
    constructor(instance) {
        // list of subscription
        this.keysList = new Set();
        this.SimpleInstance = instance;
    }
    // Create subscription
    subscribe(state, callback) {
        const ContainerComponentInstance = new ContainerComponent(state, callback);
        this.keysList.add(ContainerComponentInstance);
        return ContainerComponentInstance;
    }
    // remove the subscription
    removeSubscription(s) {
        this.keysList.delete(s);
    }
    // re render the component
    triggerReRender(key) {
        this.keysList.forEach((v) => {
            if (v.state_key_name === key) {
                v.callback();
            }
        });
    }
}
//# sourceMappingURL=container.js.map